import type { Router } from "@lit-labs/router";

let rootRouter: Router | undefined;

/** Registered once by `<app-root>` so guards and pages can navigate programmatically. */
export function setRootRouter(router: Router): void {
  rootRouter = router;
}

/** Programmatic navigation, equivalent to clicking a same-origin link to `pathname`. */
export async function navigate(pathname: string): Promise<void> {
  if (!rootRouter) {
    window.location.assign(pathname);
    return;
  }
  await rootRouter.goto(pathname);
}
